import lodash from "lodash"

export function parseTree(tree) {
  // console.log("parseTree", tree)
  if (!tree) {
    return {}
  }

  const { type, id: originalId, name, description, children, ...rest } = tree

  const matches = /Kapitel: (.*)/.exec(name)
  const isRoot = lodash.size(matches) === 2
  // const id = isRoot ? lodash.get(matches, 1) : originalId || name
  const id = originalId || name

  let childrenObject = {}

  lodash.forEach(children, child => {
    childrenObject = { ...childrenObject, ...parseTree(child) }
  })

  return {
    [id]: {
      meta: {
        id,
        type,
        name,
        description,
        isLoaded: !lodash.isEmpty(children),
        isRoot,
        ...rest
      },
      ...childrenObject
    }
  }
}

// recursively build trace to item
export function getRecursiveTrace({ targetZtn, tree, trace = [] }) {
  const { children, description, id, level, name, type, ztnFull, ztnPos } = tree

  const newTrace = [...trace, { id, ztnFull, description, level, name }]

  if (type === "item") {
    if (String(targetZtn) === String(ztnFull)) {
      return newTrace
    }
    return undefined
  }

  if (lodash.isEmpty(children)) {
    return undefined
  }

  const result = lodash.flatten(
    lodash.filter(
      lodash.map(children, child =>
        getRecursiveTrace({
          targetZtn,
          tree: child,
          trace: newTrace
        })
      ),
      Boolean
    )
  )
  if (lodash.isEmpty(result)) {
    return undefined
  }
  return result
}

export function extractMatches({ items, query }) {
  return lodash
    .flattenDeep(lodash.map(items, item => extractMatch(item, query)))
    .filter(Boolean)
}

function extractMatch(item, query) {
  const { type, children, ztnFull } = item
  if (type === "item") {
    if (lodash.startsWith(ztnFull, query)) {
      return item
    }
    return undefined
  }
  return lodash.map(children, child => extractMatch(child, query))
}
